import React, { useEffect, useState } from "react";
import ScheduleIcon from "@mui/icons-material/Schedule";
import EventIcon from "@mui/icons-material/Event";

const UpcomingTransactions = ({ transactions, updatedEmandateDetails }) => {
  const [upcomingTransactionDetails, setUpcomingTransactionDetails] = useState(
    [],
  );

  console.log("upcoming transactions data ", updatedEmandateDetails);

  const formatCurrency = (amount) =>
    new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(amount);

  const formatDateDDMMYYYY = (isoDate) => {
    if (!isoDate) return "";

    const date = new Date(isoDate);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  return (
    <>
      <div
        style={{
          background: "#fff",
          borderRadius: 12,
          padding: 20,
          boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
          width: "100%",
          maxWidth: "100%",
          boxSizing: "border-box",
        }}
      >
        {/* Header (NO SCROLL) */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            borderBottom: "1px solid #E0E0E0",
            paddingBottom: 12,
            marginBottom: 16,
          }}
        >
          <ScheduleIcon
            sx={{
              color: "#1976D2",
              fontSize: "2rem",
              "@media (max-width: 768px)": {
                fontSize: "2.5rem",
              },
            }}
          />
          <span style={{ fontSize: 16, fontWeight: 600 }}>
            Upcoming Transactions
          </span>
        </div>

        {/* Content */}
        {transactions[0]?.schedules?.length === 0 ? (
          <div
            style={{
              textAlign: "center",
              color: "#757575",
              padding: 24,
              fontSize: "12px",
              fontWeight: "500",
            }}
          >
            No upcoming transactions scheduled
          </div>
        ) : (
          /* SCROLLABLE CONTAINER */
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 14,
              width: "100%",
              maxHeight: "320px",
              overflowY: "auto",
              paddingRight: 6,
              boxSizing: "border-box",
            }}
          >
            {transactions[0]?.schedules
              ?.filter((txn) => txn?.execution === null) // Filter schedules with execution === null
              .map((txn, index) => (
                <div
                  key={txn?.id || index}
                  className="upcoming-card"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    background: "#F7F7F7",
                    padding: 16,
                    borderRadius: 10,
                    gap: 12,
                    width: "100%",
                    boxSizing: "border-box",
                  }}
                >
                  {/* LEFT */}
                  <div
                    style={{
                      display: "flex",
                      gap: 14,
                      alignItems: "flex-start",
                      flex: 1,
                      minWidth: 0,
                    }}
                  >
                    <div
                      style={{
                        width: 44,
                        height: 44,
                        borderRadius: 10,
                        background: "#0D47A1",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      <EventIcon
                        sx={{
                          color: "#fff",
                          fontSize: "2rem", // Default size for larger screens
                          "@media (max-width: 768px)": {
                            fontSize: "2.5rem", // Larger size for mobile
                          },
                        }}
                      />
                    </div>

                    <div style={{ minWidth: 0 }}>
                      <div
                        style={{
                          fontWeight: 600,
                          fontSize: 14,
                          wordBreak: "break-word",
                        }}
                      >
                        {/* {`EMI Installment ${txn?.scheduleId}`} color: "#183674", */}
                        {txn?.scheduleName && (
                          <div style={{ fontSize: 12, marginTop: 4 }}>
                            {txn?.scheduleName}
                          </div>
                        )}
                      </div>
                      <div
                        style={{
                          fontSize: 13,
                          color: "#757575",
                          marginTop: 4,
                        }}
                      >
                        Scheduled for{" "}
                        {formatDateDDMMYYYY(txn?.expectedDate) || "N/A"}
                      </div>
                    </div>
                  </div>

                  {/* RIGHT */}
                  <div style={{ textAlign: "right", flexShrink: 0 }}>
                    <div
                      style={{
                        fontWeight: 700,
                        color: "#1565C0",
                        fontSize: 15,
                      }}
                    >
                      {formatCurrency(txn?.amount || 0)}
                    </div>
                  </div>
                </div>
              ))}
          </div>
        )}
      </div>

      {/* <div
        style={{
          background: "#fff",
          borderRadius: 12,
          padding: 20,
          boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
          width: "100%", // ✅
          maxWidth: "100%", // ✅
          overflow: "auto", // ✅ CRITICAL
          boxSizing: "border-box", // ✅
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            borderBottom: "1px solid #E0E0E0",
            paddingBottom: 12,
            marginBottom: 16,
          }}
        >
          <ScheduleIcon sx={{ color: "#1976D2" }} />
          <span style={{ fontSize: 16, fontWeight: 600 }}>
            Upcoming Transactions
          </span>
        </div>

        {upcomingTransactionDetails.length === 0 ? (
          <div style={{ textAlign: "center", color: "#757575", padding: 24 }}>
            No upcoming transactions scheduled
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 14,
              width: "100%",
              overflow: "hidden",
            }}
          >
            {upcomingTransactionDetails.map((txn, index) => (
              <div
                key={txn?.id || index}
                className="upcoming-card"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  background: "#F7F7F7",
                  padding: "16px",
                  borderRadius: 10,
                  gap: 12,
                  width: "100%", // ✅
                  boxSizing: "border-box",
                }}
              >
                <div
                  className="upcoming-left"
                  style={{
                    display: "flex",
                    gap: 14,
                    alignItems: "flex-start",
                    flex: 1,
                    minWidth: 0, // ✅ VERY IMPORTANT
                  }}
                >
                  <div
                    style={{
                      width: 44,
                      height: 44,
                      borderRadius: 10,
                      background: "#0D47A1",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <EventIcon sx={{ color: "#fff" }} />
                  </div>

                  <div style={{ minWidth: 0 }}>
                    <div
                      style={{
                        fontWeight: 600,
                        fontSize: 14,
                        wordBreak: "break-word", // ✅
                      }}
                    >
                      {txn?.scheduleDescription || "EMI Payment - Installment"}  
                    </div>
                    <div
                      style={{
                        fontSize: 13,
                        color: "#757575",
                        marginTop: 4,
                      }}
                    >
                      Scheduled for {formatDateDDMMYYYY(txn?.installmentDate) || "N/A"}
                    </div>
                  </div>
                </div>

                <div
                  className="upcoming-right"
                  style={{
                    textAlign: "right",
                    flexShrink: 0,
                  }}
                >
                  <div
                    style={{
                      fontWeight: 700,
                      color: "#1565C0",
                      fontSize: 15,
                    }}
                  >
                    {formatCurrency(txn?.scheduleAmountWithTax || 0)}
                  </div>
                  <div
                    style={{
                      fontSize: 12,
                      color: "#757575",
                      marginTop: 4,
                    }}
                  >
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div> */}

      {/* 🔽 MOBILE FIX */}
      <style>{`
        @media (max-width: 600px) {
          .upcoming-card {
            flex-direction: column !important;
            align-items: flex-end !important;
          }

          .upcoming-right {
            width: 100% !important;
            text-align: left !important;
            margin-left: 58px;
            margin-top: 8px;
          }
        }
      `}</style>
    </>
  );
};

export default UpcomingTransactions;
